import React from 'react';
import ReactDOM from 'react-dom';
import indexRoutes from './routes/index.jsx';
import {  Route, Switch, Redirect } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min.js';
// import { currentUser } from './services/user-service'

import './assets/scss/style.css';

ReactDOM.render(
  <BrowserRouter>
    <Switch>
    <Route exact path="/">
      {localStorage.getItem('userToken') ? <Redirect to="/dashboard" /> : <Redirect to="/login" />}
    </Route>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} key={key} component={prop.component} />;
      })} 
    </Switch>
    </BrowserRouter>
  ,document.getElementById('root')); 
